'use client';
import { JSX } from 'react';

// Components
import AtTextAreaField from '@/components/atoms/at-textarea-field/at-textarea-field';
import { AtTextField } from '@/components/atoms/at-text-field/at-text-field';
import { AtDropdownField } from '@/components/atoms/at-dropdown-field/at-dropdown-field';
import classNames from 'classnames';

// Types
import { IMlformStepProps } from './ml-form-step.types';
import { EFormType } from '@/components/organisms/or-lead-gen-form/or-lead-gen-form.types';

export const MlFormStep = ({
  formType,
  formStep,
  className,
}: IMlformStepProps): JSX.Element => {
  return (
    <div
      className={classNames(
        'flex flex-col gap-6 md:flex-row md:flex-wrap md:justify-between md:gap-x-2 md:gap-y-8 lg:gap-x-4',
        className,
      )}
    >
      {formStep.formFields.map((field) => {
        switch (field.type) {
          case 'text':
          case 'phone':
          case 'email':
            return (
              <div
                key={`field-${field.id}`}
                className={classNames('basis-full', {
                  'md:basis-[calc(50%-0.5rem)] lg:basis-[calc(50%-1rem)]':
                    !field.fullWidth,
                  'md:basis-full': field.fullWidth,
                })}
              >
                <AtTextField
                  key={field.id}
                  label={field.label}
                  id={field.id}
                  type={field.type}
                  required={field.required}
                />
              </div>
            );
          case 'dropdown':
            if (
              field.id === 'topic' ||
              (formType === EFormType.CONTACT_US &&
                field.id === 'buildLocation')
            ) {
              return (
                <div key={`field-${field.id}`} className="basis-full">
                  <div className="w-full md:w-[calc(50%-0.5rem)] lg:w-[calc(50%-1rem)]">
                    <AtDropdownField
                      key={field.id}
                      label={field.label}
                      id={field.id}
                      required={field.required}
                      options={field.options || []}
                      icon={field.icon}
                    />
                  </div>
                </div>
              );
            }
            return (
              <div
                key={`field-${field.id}`}
                className="basis-full md:basis-[calc(50%-0.5rem)] lg:basis-[calc(50%-1rem)]"
              >
                <AtDropdownField
                  key={field.id}
                  label={field.label}
                  id={field.id}
                  required={field.required}
                  options={field.options || []}
                  icon={field.icon}
                />
              </div>
            );
          case 'checkbox':
            if (field.children) {
              return field.children;
            }
          case 'textarea':
            return (
              <div
                key={`field-${field.id}`}
                className={classNames('basis-full', {
                  'md:basis-[calc(50%-0.5rem)] lg:basis-[calc(50%-1rem)]':
                    !field.fullWidth,
                  'md:basis-full': field.fullWidth,
                })}
              >
                <AtTextAreaField
                  key={field.id}
                  label={field.label}
                  id={field.id}
                  required={field.required}
                  placeholder={field.placeholder}
                  rows={field.rows}
                />
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
